import { Link } from "@/lib/router-compat";
import { useEffect } from "react";
import { useLocation } from "@/lib/router-compat";
import Navbar from "@/components/Layout/Navbar";
import Footer from "@/components/Layout/Footer";
import { Button } from "@/components/ui/button";
import { Card, CardContent } from "@/components/ui/card";
import { ArrowRight, Home, Search } from "lucide-react";
import SEOHead from "@/components/SEOHead";

const NotFound = () => {
  const location = useLocation();

  useEffect(() => {
    console.error("404 Error: User attempted to access non-existent route:", location.pathname);
  }, [location.pathname]);

  const popularPages = [
    { to: "/what-is-nearshoring", label: "What is Nearshoring?" },
    { to: "/nearshoring-vs-offshoring-vs-outsourcing", label: "Nearshoring vs Offshoring vs Outsourcing" },
    { to: "/companies", label: "Top Software Companies in Africa" },
    { to: "/blog/egypt-outsourcing-costs", label: "Egypt Software Outsourcing Cost Analysis" },
    { to: "/blog/nearshore-outsourcing-guide", label: "Nearshore Outsourcing Guide for Africa" },
  ];

  return (
    <div className="min-h-screen bg-background">
      <SEOHead
        titleEn="Page Not Found | Nearshore.Africa"
        titleDe="Seite nicht gefunden | Nearshore.Africa"
        descriptionEn="The page you're looking for doesn't exist. Explore nearshore outsourcing solutions."
        descriptionDe="Die gesuchte Seite existiert nicht. Entdecken Sie Nearshore-Outsourcing-Lösungen."
        noindex={true}
      />
      <Navbar />
      <main className="pt-24 pb-32">
        <div className="container mx-auto px-6 max-w-2xl">
          <div className="text-center pt-16 mb-16">
            <div className="text-xs uppercase tracking-[0.2em] text-muted-foreground mb-5">Error 404</div>
            <h1 className="text-7xl md:text-8xl font-semibold tracking-[-0.04em] mb-6">
              404
            </h1>
            <h2 className="text-2xl md:text-3xl font-semibold tracking-[-0.028em] mb-4">
              Page Not Found
            </h2>
            <p className="text-muted-foreground max-w-lg mx-auto leading-relaxed">
              The page you're looking for doesn't exist or may have been moved. 
              Explore our nearshore outsourcing resources below.
            </p>
          </div>

          <div className="flex flex-col sm:flex-row gap-3 justify-center mb-16">
            <Button size="lg" asChild>
              <Link to="/">
                <Home className="w-4 h-4" />
                Back to Home
              </Link>
            </Button>
            <Button size="lg" variant="glass" asChild>
              <Link to="/blog">
                <Search className="w-4 h-4" />
                Browse Blog
              </Link>
            </Button>
          </div>

          <Card>
            <CardContent className="p-8">
              <div className="text-xs uppercase tracking-[0.2em] text-muted-foreground mb-5">Popular Pages</div>
              <ul className="divide-y divide-border/60">
                {popularPages.map((page) => (
                  <li key={page.to}>
                    <Link
                      to={page.to}
                      className="flex items-center justify-between py-3 text-foreground/80 hover:text-foreground transition-colors group"
                    >
                      <span>{page.label}</span>
                      <ArrowRight className="w-4 h-4 opacity-40 group-hover:opacity-100 group-hover:translate-x-1 transition-all" />
                    </Link>
                  </li>
                ))}
              </ul>
            </CardContent>
          </Card>
        </div>
      </main>
      <Footer />
    </div>
  );
};

export default NotFound;
